import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-characteristics',
  storeModule.createStoreModule('real-estate-developments-characteristics')
)
